import { useActiveFeatureFlags } from "@pharaday/feature-flag";

import useQueryAccessibleTools from "../apis/useQueryAccessibleTools";
import type { Tool } from "../core/domain/entities/tool";
import { getToolFeatureFlag } from "../utils/get-tool-feature-flag";

const useFilteredToolListByFeatureFlag = () => {
  const { data, isFetching } = useQueryAccessibleTools();
  const activeFeatureFlags = useActiveFeatureFlags();

  const handleFilterTool = (tool: Tool) => {
    if (!activeFeatureFlags) {
      return true;
    }

    const toolFeatureFlag = getToolFeatureFlag(tool.type);
    if (!toolFeatureFlag) {
      return true;
    }

    return activeFeatureFlags.includes(toolFeatureFlag);
  };

  return {
    data: data?.filter(handleFilterTool),
    isFetching,
  };
};

export default useFilteredToolListByFeatureFlag;
